<div class="sso-background">
  <div class="logout-text-box">
    <div>
      <h2 class="logout-title" i18n="@@ssoLogoutHeader">
        <fa-icon class="lock-icon" aria-hidden="true" [icon]="faLock"></fa-icon>
        Your user is logged out
      </h2>
    </div>
    <hr />
    <div i18n="@@ssoLogoutMessage">
      Please close your browser window or return to your usual login page to log back in.
    </div>
  </div>
</div>
